export default __webpack_public_path__ + "static/media/airbnbLogo.adfbece3.png";